// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const UpdatePrice = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.793 6.207a1 1 0 0 1 1.414 0l1.586 1.585c.39.39.39 1.025 0 1.415L9 15H6v-3zM7 12.414V14h1.585l3.853-3.854-1.585-1.585zm4.56-4.56 1.585 1.585.94-.939L12.5 6.914z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M5.266 3.539v.786M5.266 8.255v.786M4.087 8.255h1.768a.983.983 0 0 0 0-1.965H4.676a.983.983 0 1 1 0-1.965h1.769"
    />
  </svg>
);
const ForwardRef = forwardRef(UpdatePrice);
export default ForwardRef;
